const WHATSAPP_URL = "https://wa.me/message/6X77HRWZGKPQH1";
const INSTAGRAM_URL = "https://www.instagram.com/vellora__studio/";
const VELLORA_SITE = "https://vellorastudio.suapagina.net.br/";

export default function Footer() {
  const supportLinks = [
    { label: "Frete e entrega", href: "#shipping" },
    { label: "Trocas e devoluções", href: "#returns" },
    { label: "Como comprar", href: "#how-to-order" },
    { label: "Fale com a gente", href: "#contact" },
  ];
  const shopLinks = [
    { label: "Todos os produtos", href: "#shop" },
    { label: "Novidades", href: "#new" },
    { label: "Edição limitada", href: "#limited" },
    { label: "Guia de presentes", href: "#gift" },
  ];

  return (
    <footer className="w-full bg-secondary-100/70 border-t border-background-200/60">
      <div className="max-w-6xl mx-auto px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-flower-line text-lg"></i>
              </div>
              <span className="font-heading text-xl text-foreground-950 font-medium">
                Casa Flor
              </span>
            </div>
            <p className="text-sm text-foreground-700 mt-4 leading-relaxed max-w-sm">
              Loja online de decoração e casa, com peças artesanais feitas à mão
              no Brasil. Materiais naturais e design autoral.
            </p>
            <div className="flex items-center gap-2 mt-6">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-background-50 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-[16px]"></i>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full bg-background-50 flex items-center justify-center text-foreground-700 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-[16px]"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-[12px] tracking-[0.18em] uppercase text-foreground-500 mb-4">
              Loja
            </p>
            <ul className="space-y-3">
              {shopLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[12px] tracking-[0.18em] uppercase text-foreground-500 mb-4">
              Ajuda
            </p>
            <ul className="space-y-3">
              {supportLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-800 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[12px] text-foreground-600">
            © 2026 Casa Flor · Modelo demonstrativo
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-5 text-[12px] text-foreground-600">
            <a href="#privacy" className="hover:text-primary-600 cursor-pointer">
              Privacidade
            </a>
            <a href="#terms" className="hover:text-primary-600 cursor-pointer">
              Termos
            </a>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-map-pin-line"></i>
              Goiânia - GO · Atendimento digital em todo o Brasil
            </span>
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-background-300/50 text-center">
          <p className="text-[12px] text-foreground-600">
            Modelo demonstrativo criado pela Vellora Studio.{" "}
            <a
              href={VELLORA_SITE}
              target="_blank"
              rel="noreferrer"
              className="text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
            >
              Desenvolvido pela Vellora Studio
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}